import 'leaflet/dist/leaflet.css';

import L, { LatLng } from 'leaflet';
import { useEffect, useState } from 'react';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';

const madriwaIcon = L.icon({
  iconUrl: 'marker-icon.png',
  shadowUrl: 'marker-shadow.png',

  iconSize: [25, 41], // size of the icon
  shadowSize: [41, 41], // size of the shadow
  iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
  shadowAnchor: [12, 41], // the same for the shadow
  popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
});

type MapProps = {
  centerLatLng?: LatLng;
  baseLayer?: string;
  initZoom?: number;
  minZoom?: number;
  maxZoom?: number;
  className?: string;
};

export const Map: React.FC<MapProps> = ({
  className,
  centerLatLng,
  baseLayer = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', // 'https://api.mapbox.com/styles/v1/mapbox/light-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoid2hlcmVzbXl3YXZlcyIsImEiOiJjanJ6cGZtd24xYmU0M3lxcmVhMDR2dWlqIn0.QQSWbd-riqn1U5ppmyQjRw',
  initZoom = 12,
  minZoom = 2,
  maxZoom = 18,
}) => {
  const [mapReady, setMapReady] = useState(false);
  const [internalCenterLatLng, setInternalCenterLatLng] = useState<LatLng>();
  const [zoomInternalCenterLatLng, setZoomInternalCenterLatLng] = useState<number>();

  const onChangeMapReady = () => {
    setMapReady(true);
  };

  useEffect(() => {
    if (centerLatLng) {
      setZoomInternalCenterLatLng(16);
      setInternalCenterLatLng(centerLatLng);
    } else {
      setZoomInternalCenterLatLng(undefined);
      setInternalCenterLatLng(undefined);
    }
  }, [centerLatLng]);

  interface FlyToProps {
    centerLatLng?: LatLng;
    zoomInternalCenterLatLng?: number;
  }
  function FlyTo({ centerLatLng, zoomInternalCenterLatLng }: FlyToProps) {
    const map = useMap();
    if (centerLatLng) {
      zoomInternalCenterLatLng
        ? map.flyTo(centerLatLng, zoomInternalCenterLatLng)
        : map.flyTo(centerLatLng);
    } else {
      map.flyTo(new LatLng(40.416729, -3.703339));
    }

    return null;
  }

  return (
    <MapContainer
      className="h-full w-full"
      center={internalCenterLatLng ?? new LatLng(40.416729, -3.703339)}
      zoom={initZoom}
      zoomControl={false}
      scrollWheelZoom={true}
      maxZoom={maxZoom}
      minZoom={minZoom}
      attributionControl={false}
      doubleClickZoom={false}
      whenReady={onChangeMapReady}
    >
      {internalCenterLatLng && (
        <Marker
          position={[internalCenterLatLng.lat, internalCenterLatLng.lng]}
          icon={madriwaIcon}
        ></Marker>
      )}
      <TileLayer url={baseLayer} />
      {internalCenterLatLng && (
        <FlyTo
          centerLatLng={internalCenterLatLng}
          zoomInternalCenterLatLng={zoomInternalCenterLatLng}
        />
      )}
    </MapContainer>
  );
};

export default Map;
